module.exports = __webpack_public_path__ + "img/fn-desc.552eb6a7.png";